import { createStyles, WithStyles, withStyles } from "@material-ui/core/styles";
import * as React from "react";
import styled from "styled-components";

import { CardWithHeader } from "..";
import { Button } from "../buttons";
import { Text } from "../text";

const styles = createStyles({
    root: {
        maxWidth: 600,
    },
});

const HeaderWrapper = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    width: 100%;
`;

const Title = styled.span`
    font-size: 64px;
    color: #ffffffad;
    width: 100%;
    text-align: center;
    line-height: 5.5rem;
`;

const ContentWrapper = styled.div`
    margin-bottom: 80px;
`;

interface ErrorCardProps extends WithStyles<typeof styles> {
    title?: string;
    subtitle?: string;
    onClose: () => void;
    children: React.ReactNode;
    buttonTitle?: string;
    noPaper?: boolean;
    fullSize?: boolean;
}

export const ErrorCard = withStyles(styles, { name: "ErrorCard" })((props: ErrorCardProps) => {
    const {
        classes,
        onClose,
        title = "oops!",
        subtitle = "we have encountered something unexpected",
        children,
        buttonTitle = "close",
        noPaper,
        ...other
    } = props;

    return (
        <CardWithHeader
            align="full"
            color="danger"
            noPaper={noPaper}
            classes={classes}
            {...other}
            header={
                <HeaderWrapper>
                    <Title>{title}</Title>
                    <Text variant="caption" color="flat">
                        {subtitle}
                    </Text>
                </HeaderWrapper>
            }
            actions={
                <Button variant="text" color="primary" onClick={onClose}>
                    {buttonTitle}
                </Button>
            }
        >
            <ContentWrapper>{children}</ContentWrapper>
        </CardWithHeader>
    );
});
